import React, { Component } from "react";
import UploadService from "../services/upload-files.service";
import {  Button, Col } from 'react-bootstrap';
import {URL_API}from "../services/common";



export default class UploadFilesTurismo extends Component {
  constructor(props) {
    super(props);
    this.selectFile = this.selectFile.bind(this);
    this.upload = this.upload.bind(this);

    this.state = {
      selectedFiles: undefined,
      currentFile: undefined,
      currentFile1: undefined,
      currentFile2: undefined,
      currentFile3: undefined,
      progress: 0,
      message: "",
      entrada: null,
      fileInfos: [],
      face: "",
    };
  }

  componentDidMount() {
    UploadService.getFiles().then((response) => {
      this.setState({
        fileInfos: response.data,
      });
    });

   


  }


  selectFile(event) {
    this.setState({
      selectedFiles: event.target.files,
    });
  }

  

  upload(foto, i) {
    let currentFile = this.state.selectedFiles[0];

    this.setState({
      progress: 0,
      currentFile: currentFile,
    });

    UploadService.upload(foto, currentFile, (event) => {
      this.setState({
        progress: Math.round((100 * event.loaded) / event.total),
      });
    })
      .then((response) => {
        this.setState({
          message: response.data.message,
        });
        window.location.reload();
        return UploadService.getFiles();
      })
      .then((files) => {
        this.setState({
          fileInfos: files.data,
        });
      })
      .catch(() => {
        this.setState({
          progress: 0,
          message: "Could not upload the file!",
          currentFile: undefined,
        });
      });

    this.setState({
      selectedFiles: undefined,
    });
  }
  
  render() {
    const {
      selectedFiles,
      currentFile,
      progress,
      message,
     } = this.state;
     
    return (
      <div style={{ minHeight: 400 }}>
        {/*Foto 4 */}
        <Col lg={12}>
          <div style={{ margin: "20px" }}>
            <h3>Foto 1 </h3>
          </div>
          <div>
            
            <img alt="" src={`${URL_API}/home/imagen/foto4.png`} height="100%" width="100%" />
          </div>
          {currentFile && (
            <div className="progress">
              <div
                className="progress-bar progress-bar-info progress-bar-striped"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: progress + "%" }}
              >
                {progress}%
              </div>
            </div>
          )}

          <Col lg={12}>
            <label className=" btn-default ">
              <input type="file" onChange={this.selectFile} />
            </label>
          </Col>
          <div className="d-grid gap-2">
            <Button
              block
              className="btn btn-success mt-2 mb-2"
              disabled={!selectedFiles}
              onClick={() => this.upload("foto4.png")}
            >
              Subir
            </Button>
          </div>
          <div className="alert alert-light" role="alert">
            {message}
          </div>
        </Col>
        {/*Foto 5 */}
        <Col lg={12}>
          <div style={{ margin: "20px" }}>
            <h3>Foto 2 </h3>
          </div>
          <div>
            <img alt="" src={`${URL_API}/home/imagen/foto5.png`} height="100%" width="100%" />
          </div>
          {currentFile && (
            <div className="progress">
              <div
                className="progress-bar progress-bar-info progress-bar-striped"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: progress + "%" }}
              >
                {progress}%
              </div>
            </div>
          )}
          <Col lg={12}>
            <label className=" btn-default ">
              <input type="file" onChange={this.selectFile} />
            </label>
          </Col>
          <div className="d-grid gap-2">
            <Button
              block
              className="btn btn-success mt-2 mb-2"
              disabled={!selectedFiles}
              onClick={() => this.upload("foto5.png")}
            >
              Subir
            </Button>
          </div>

          <div className="alert alert-light" role="alert">
            {message}
          </div>
        </Col>
        
        


      </div>
    );
  }
}